import React from "react";
import styles from "./Range.module.scss";
import {
  Controller,
  type Control,
  type FieldValues,
  type RegisterOptions,
  type UseFormRegisterReturn,
} from "react-hook-form";
import withLabelAndError from "../withLabelAndError";

interface RangeProps<TFieldValues extends FieldValues = FieldValues> {
  control?: Control<TFieldValues>;
  register?: (name: string, options?: RegisterOptions) => UseFormRegisterReturn;
  validations?: RegisterOptions;
  name: string;
  placeholder?: string;
  min: number;
  max: number;
  // allow other native input props like disabled, step, etc.
  [key: string]: any;
}

const Range = <TFieldValues extends FieldValues = FieldValues>({
  control,
  register,
  validations,
  name,
  placeholder,
  ...rest
}: RangeProps<TFieldValues>) => {
  const { min, max } = rest;

  const renderRange = (field: Partial<UseFormRegisterReturn> = {}) => (
    <div className={styles.rangeInput}>
      <input
        {...field}
        {...rest}
        id={name}
        type="range"
        className={styles.inputField}
        placeholder={placeholder}
      />
      <div className={styles.rangeLabel}>
        {Array.from({ length: max - min + 1 }, (_, i) => min + i).map((num) => (
          <button
            key={num}
            type="button"
            onClick={() => {
              field.onChange?.({ target: { value: num, name } });
            }}
          >
            {num}
          </button>
        ))}
      </div>
    </div>
  );

  if (control) {
    return (
      <Controller
        control={control}
        rules={validations}
        name={name}
        render={({ field }) => renderRange(field)}
      />
    );
  } else {
    const field = register ? register(name, validations) : {};
    return renderRange(field);
  }
};

export default withLabelAndError(Range);
export { Range };
